// FILE: components/layout/ServerActionErrorBoundary.tsx
// Detect Server Action 404 (stale deployment) → auto reload.
// Client-side fetch wrapper — catch response 404 có Next-Action header.

"use client";

import { useEffect } from "react";

export default function ServerActionErrorBoundary() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const originalFetch = window.fetch;
    let isReloading = false;

    window.fetch = async function (...args: Parameters<typeof fetch>) {
      const [input, init] = args;
      const response = await originalFetch.apply(this, args);

      // Chỉ check POST request có Next-Action header (Server Action call)
      const hasNextAction =
        init?.headers &&
        (
          (init.headers as Record<string, string>)["next-action"] ||
          (init.headers instanceof Headers && init.headers.get("next-action"))
        );

      if (response.status === 404 && hasNextAction && !isReloading) {
        isReloading = true;
        console.warn("[ServerAction] 404 detected — stale deployment, reloading...");
        // Delay nhẹ để tránh race condition
        setTimeout(() => window.location.reload(), 100);
      }

      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return null;
}